import { Component, inject, OnInit } from '@angular/core';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 'player',
  imports: [],
  templateUrl: './player.component.html',
  styleUrl: './player.component.scss',
})
export class PlayerComponent implements OnInit {
  playerService = inject(PlayerService);

  ngOnInit() {
    this.playerService.initPlayer('video-player');
  }
}
